import { render, staticRenderFns } from "./AlertButton.vue?vue&type=template&id=680d5dfe&"
import script from "./AlertButton.vue?vue&type=script&lang=js&"
export * from "./AlertButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports